export const SPONTANEOUS = { id: 'spontaneous', label: 'Travaglio ad inizio spontaneo' };
export const INDUCED = { id: 'induced', label: 'Travaglio indotto' };
export const WITHOUT = { id: 'without', label: 'Senza travaglio (solo per TC elettivo)' };
export const URGENT = { id: 'urgent', label: 'TC urgente (fuori travaglio)' };
export const PILOTED = { id: 'piloted', label: 'Travaglio ad inizio pilotato' };
